import { render, staticRenderFns } from "./selectPolicyThreshold.vue?vue&type=template&id=7ed583ca&scoped=true"
import script from "./selectPolicyThreshold.vue?vue&type=script&lang=js"
export * from "./selectPolicyThreshold.vue?vue&type=script&lang=js"
import style0 from "./selectPolicyThreshold.vue?vue&type=style&index=0&id=7ed583ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed583ca",
  null
  
)

export default component.exports